export const ROUTES_NS = 'routes';

export const i18n = {
  en: {
    workflows: 'Workflows',
    work: 'Work',
    home: 'Home',
    performance: 'Performance',
    people: 'People',
    assets: 'Assets',
    workAdp: 'Actions',
    performanceAdp: 'Reporting',
    reporting: 'Reporting',
    dataExplorer: 'Data Explorer',
  },
};
